import axios from "axios";
import { Constants } from "./../config/constants";

const API_KEY = '6WidIVwVzl6LAOgOJfUa0adQ5ax2o0ks8k6rU5kP';
const CLIENT_ID = "6u54ep11u2eobf2dglo402midu";
const API_DOMAIN = 'https://apipreprod.developersinmarutisuzuki.in/loginviauserpass/v1/common/LoginViaUsernamePassword/partner';

const api = axios.create({
  baseURL: API_DOMAIN,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': API_KEY
  }
});

/**
 * Create API request configuration
 * @param {string} endpoint - The API endpoint
 * @param {object} data - Request payload
 * @returns {object} Axios config object
 */
const createConfig = (endpoint, data) => ({
  method: 'post',
  maxBodyLength: Infinity,
  url: endpoint,
  data: JSON.stringify(data)
});

/**
 * Make API request and return data
 * @param {object} config - Axios config
 * @param {string} errorMessage - Error message for exception
 * @returns {Promise} Response data
 */
const makeRequest = async (config, errorMessage) => {
  const requestId = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
  try {
    console.log(`[${requestId}] ℹ️ INITIATING API REQUEST`, {
      endpoint: config.url,
      method: config.method,
      timestamp: new Date().toISOString()
    });
    console.log(`[${requestId}] 📤 REQUEST PAYLOAD:`, JSON.parse(config.data));

    const response = await api.request(config);
    
    console.log(`[${requestId}] ✅ API REQUEST SUCCESS`, {
      status: response.status,
      statusText: response.statusText,
      timestamp: new Date().toISOString()
    });
    console.log(`[${requestId}] 📥 RESPONSE DATA:`, response?.data);
    
    return response?.data?.data;
  } catch (error) {
    const errorDetails = {
      requestId,
      message: error.message,
      status: error.response?.status,
      statusText: error.response?.statusText,
      errorData: error.response?.data,
      endpoint: config.url,
      timestamp: new Date().toISOString()
    };
    
    console.error(`[${requestId}] ❌ API REQUEST FAILED - ${errorMessage}`, errorDetails);
    console.error(`[${requestId}] 🔍 DETAILED ERROR:`, error);
    
    throw new Error(`[${requestId}] ${errorMessage}: ${error.message}`);
  }
};

export const getADFSLoginUrl = async () => {
  console.log('🔐 [LOGIN] STEP 1: Initiating ADFS Login URL request');
  try {
    const payload = {
      redirectUrl: Constants.loginRedirectUrl,
      clientId: CLIENT_ID
    };
    console.log('🔐 [LOGIN] STEP 2: Payload prepared with redirectUrl:', Constants.loginRedirectUrl);

    const config = createConfig('login-with-federation', payload);
    console.log('🔐 [LOGIN] STEP 3: Config created, making request to:', config.url);
    
    const result = await makeRequest(config, 'Unable to initiate login');
    console.log('🔐 [LOGIN] STEP 4: ✅ Successfully retrieved login URL',result);
    return result;
  } catch (error) {
    console.error('🔐 [LOGIN] ❌ FAILED:', error.message);
    throw error;
  }
};

export const getADFSLogoutUrl = async () => {
  console.log('🚪 [LOGOUT] STEP 1: Initiating ADFS Logout URL request');
  try {
    const payload = {
      redirectUrl: Constants.loginRedirectUrl,
      clientId: CLIENT_ID
    };
    console.log('🚪 [LOGOUT] STEP 2: Payload prepared with redirectUrl:', Constants.loginRedirectUrl);

    const config = createConfig('logout-with-federation', payload);
    console.log('🚪 [LOGOUT] STEP 3: Config created, making request to:', config.url);
    
    const result = await makeRequest(config, 'Unable to initiate logout');
    console.log('🚪 [LOGOUT] STEP 4: ✅ Successfully retrieved logout URL');
    return result;
  } catch (error) {
    console.error('🚪 [LOGOUT] ❌ FAILED:', error.message);
    throw error;
  }
};

export const getADFSTokenUrl = async (code) => {
  console.log('🔑 [TOKEN] STEP 1: Initiating ADFS Token request');
  
  if (!code) {
    console.error('🔑 [TOKEN] ❌ FAILED: Authorization code is required but was not provided');
    throw new Error('Authorization code is required');
  }
  
  try {
    console.log('🔑 [TOKEN] STEP 2: Authorization code received (length:', code.length, ')');
    
    const payload = {
      code,
      redirectUrl: Constants.loginRedirectUrl,
      clientId: CLIENT_ID
    };
    console.log('🔑 [TOKEN] STEP 3: Token payload prepared with code and redirectUrl:', Constants.loginRedirectUrl);

    const config = createConfig('get-token', payload);
    console.log('🔑 [TOKEN] STEP 4: Config created, making request to:', config.url);
    
    const result = await makeRequest(config, 'Unable to retrieve token');
    console.log('🔑 [TOKEN] STEP 5: ✅ Successfully retrieved authentication token');
    return result;
  } catch (error) {
    console.error('🔑 [TOKEN] ❌ FAILED:', error.message);
    throw error;
  }
};

